import { Button, Input } from "@nextui-org/react";
import { useEffect, useRef, useState } from "react";
import { Link, Navigate, useActionData, useNavigate } from "react-router-dom";
import fetchWrapper from "../utils/fetch";
import { useAuth } from "../contexts/auth-context";
import { toast } from "react-toastify";

export default function ForgetPasswordPage() {
  const navigate = useNavigate();
  const [{ isAuthenticated }] = useAuth();
  const [status, setStatus] = useState("init");

  const emailRef = useRef(null);

  const isLoading = status === "loading";

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = emailRef.current.value;

    try {
      setStatus("loading");
      const data = await fetchWrapper.post(
        "/forgot-password",
        {
          email: email,
        },
        true,
      );
      if (data.sent) {
        toast.success("ایمیل با موفقیت ارسال شد.");
      } else {
        toast.error(
          "ایمیل شما در سامانه موجود نیست یا امکان ارسال ایمیل وجود ندارد. لطفا بعدا دوباره تلاش کنید.",
        );
      }
      setStatus("init");
    } catch (err) {
      toast.error(
        "ایمیل شما در سامانه موجود نیست یا امکان ارسال ایمیل وجود ندارد. لطفا بعدا دوباره تلاش کنید.",
      );
      setStatus("init");
      console.log(err);
    }
  };

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <div>
      <div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-12">
          <div className="text-center w-full">
            <h2 className="text-2xl font-bold">فراموشی رمز عبور</h2>
            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
              <form className="space-y-6 mt-10" onSubmit={handleSubmit}>
                <div>
                  <div className="mt-2">
                    <Input
                      type="text"
                      label="ایمیل"
                      name="email"
                      placeholder="ایمیل را وارد کنید .."
                      labelPlacement="outside"
                      isRequired={true}
                      ref={emailRef}
                      startContent={
                        <svg
                          aria-hidden="true"
                          fill="none"
                          focusable="false"
                          height="1em"
                          role="presentation"
                          viewBox="0 0 24 24"
                          width="1em"
                          className="text-2xl text-default-400 pointer-events-none flex-shrink-0"
                        >
                          <path
                            d="M17 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V8.5C22 5 20 3.5 17 3.5ZM17.47 9.59L14.34 12.09C13.68 12.62 12.84 12.88 12 12.88C11.16 12.88 10.31 12.62 9.66 12.09L6.53 9.59C6.21 9.33 6.16 8.85 6.41 8.53C6.67 8.21 7.14 8.15 7.46 8.41L10.59 10.91C11.35 11.52 12.64 11.52 13.4 10.91L16.53 8.41C16.85 8.15 17.33 8.2 17.58 8.53C17.84 8.85 17.79 9.33 17.47 9.59Z"
                            fill="currentColor"
                          />
                        </svg>
                      }
                    />
                  </div>
                </div>
                <div>
                  <Button
                    type="submit"
                    color="primary"
                    isLoading={isLoading}
                    isDisabled={isLoading}
                  >
                    {isLoading ? "در حال ارسال" : "ارسال ایمیل"}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
